
import React, {useContext, useRef} from "react";
import classnames from "classnames";
// reactstrap components
import {
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Row,
    Col,
    CardHeader,Card, CardBody, Button, FormGroup
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import { UserLoginContext } from "../../context/UserLoginContext";
import { CollectionsContext } from "../../context/CollectionsContext";
import {useHistory} from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import rest from "../../API/api";
import { authenticatedFetch } from "../../services/authService";

const AddGeneralCollection = () => {
    // eslint-disable-next-line
    const [collectionsState, setCollectionsState] = useContext(CollectionsContext);
    const [userState, setUserState] = useContext(UserLoginContext);
    const [title, settitle] = React.useState("");
    const [titleState, settitleState] = React.useState("");
    const [titleFocus, settitleFocus] = React.useState("");
    // eslint-disable-next-line
    const [description, setdescription] = React.useState("");
    const [descriptionState, setdescriptionState] = React.useState("");
    const [descriptionFocus, setdescriptionFocus] = React.useState("");

    const [alert, setalert] = React.useState(null);
    const history = useHistory();
    const notificationAlertRef = useRef(null);

    const stateFunctions = {
        settitleState: (value) => settitleState(value),
        settitle: (value) => settitle(value),
        setdescriptionState: (value) => setdescriptionState(value),
        setdescription: (value) => setdescription(value),
    };

    const notify = (type, message) => {
        const options = {
            place: "tc",
            message: <div>{message}</div>,
            type: type,
            icon: "tim-icons icon-bell-55",
            autoDismiss: 5,
        };
        notificationAlertRef.current.notificationAlert(options);
    };

    // function that verifies if a string has a given length or not
    const verifyLength = (value, length) => {
        if (value.length >= length) {
            return true;
        }
        return false;
    };
    // function that verifies if value contains only numbers
    const verifyNumber = (value) => {
        var numberRex = new RegExp("^[0-9]+$");
        if (numberRex.test(value)) {
            return true;
        }
        return false;

    };
    const change = (event, stateName, type, stateNameEqualTo, maxValue) => {
        switch (type) {
            case "length":
                if (verifyLength(event.target.value, stateNameEqualTo)) {
                    stateFunctions["set" + stateName + "State"]("has-success");
                } else {
                    stateFunctions["set" + stateName + "State"]("has-danger");
                }
                stateFunctions["set" + stateName](event.target.value);
                break;
            case "number":
                if (verifyNumber(event.target.value, stateNameEqualTo)) {
                    stateFunctions["set" + stateName + "State"]("has-success");
                } else {
                    stateFunctions["set" + stateName + "State"]("has-danger");
                }
                stateFunctions["set" + stateName](event.target.value);
                break;
            default:
                break;
        }

    };
    /*eslint-disable-next-line*/
    const isValidated = () => {
        if (
            titleState === "has-success" &&
            descriptionState === "has-success"
        ) {
            return true;
        } else {
            if (titleState !== "has-success") {
                settitleState("has-danger");
            }
            if (descriptionState !== "has-success") {
                setdescriptionState("has-danger");
            }
            return false;
        }
    };

    const _addCollectionAlert = async () => {
        //console.log("email to delete:" + email);
        //debugger;
        setalert(
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Yes, save it!"
                confirmBtnBsStyle="info"
                cancelBtnBsStyle="default"
                title="Are you sure?"
                style={{display: "block"}}
                onConfirm={() => {
                    _add_collection();
                    setalert(null);
                }}
                onCancel={() =>  {
                    setalert(null);
                }}
            >
                Are you sure you want to save this collection?
            </SweetAlert>
        );
    };
    const _add_collection = async (id) => {
        try {
            var tempURL = rest.generalCollections;
            const response = await authenticatedFetch(tempURL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    Title: title,
                    Description: description,
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Save failed:', errorData);
                throw new Error(errorData.message || 'Failed to save collection');
            }

            const addCollectionJSON = await response.json();
            setCollectionsState((prevcollectionsState) => ({
                ...prevcollectionsState,
                generalCollections: addCollectionJSON
            }));

            notify("success", "Collection has been added successfully!");
            setTimeout(() => {
                history.push("/admin/generalcollections");
            }, 1000);
        } catch (error) {
            console.error('Error saving collection:', error);
            notify("danger", error.message || 'Failed to save collection.');
        }
    };

    if (userState.status) {
      return (
          <>
              <div className="rna-container">
                  <NotificationAlert ref={notificationAlertRef} />
              </div>
              <div className="content">
                  <Col md={8} className="ml-auto mr-auto">
                      <h2 className="text-center">Add a General Collection</h2>
                  </Col>

                  <Card>
                      <CardHeader>Collection Information:</CardHeader>
                      <CardBody>
                          <Row>
                              <Col md={5} mdOffset={1}>
                                  <FormGroup className={`has-label ${titleState}`}>
                                      <label>Collection Title *</label>
                                      <Input
                                          name="title"
                                          type="text"
                                          value={title}
                                          onChange={(e) => change(e, "title", "length",1)}
                                      />
                                      {titleState === "has-danger" ? (
                                          <label className="error">
                                              Please enter a valid collection title.
                                          </label>
                                      ) : null}
                                  </FormGroup>
                              </Col>
                              <Col md={3} mdOffset={1}>
                                  <FormGroup className={`has-label ${descriptionState}`}>
                                      <label>Collection Description *</label>
                                      <Input
                                          name="description"
                                          type="text"
                                          value={description}
                                          onChange={(e) => change(e, "description", "length",1)}
                                      />
                                      {descriptionState === "has-danger" ? (
                                          <label className="error">
                                              Please enter a valid description.
                                          </label>
                                      ) : null}
                                  </FormGroup>
                              </Col>
                          </Row>
                      </CardBody>
                  </Card>
                  <Card>
                  <CardBody>
                          <Row>
                              <Col md={1} mdOffset={1} xs={5} xsOffset={1}>
                                  <Button color="info" className="animation-on-hover" onClick={ async () => {
                                      if(isValidated()) {
                                          await _addCollectionAlert();
                                      }
                                  }}>Save
                                  </Button>
                              </Col>
                              <Col md={1} mdOffset={1} xs={5} xsOffset={1}>
                                  <Button color="danger" className="animation-on-hover" onClick={ async () => {
                                          let tURL = "/admin/generalcollections";
                                          await history.push(tURL);
                                  }}>Cancel
                                  </Button>
                              </Col>
                          </Row>
                      </CardBody>
                  </Card>
                  {alert}
              </div>
          </>
      );
    }
    else {
        //alert("You must be logged in and have an active subscription to access this page!");
        history.push("/admin/dashboard");
        return(null);
    }
};
export default AddGeneralCollection;
